// Firestore data converters — give us typed reads/writes via withConverter().
// Spec: 4 collections — users / audios / markers / regions

import {
  type DocumentData,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from "firebase/firestore";
import type {
  AudioDoc,
  ConfigEventDoc,
  EchoDoc,
  FragmentDoc,
  ListenDoc,
  MarkerDoc,
  MessageDoc,
  PinDoc,
  RegionDoc,
  UserDoc,
} from "./types";

function makeConverter<T extends DocumentData>(): FirestoreDataConverter<T> {
  return {
    toFirestore: (data: T) => data,
    fromFirestore: (snap: QueryDocumentSnapshot) => snap.data() as T,
  };
}

export const userConverter = makeConverter<UserDoc>();
export const audioConverter = makeConverter<AudioDoc>();
export const echoConverter = makeConverter<EchoDoc>();
export const markerConverter = makeConverter<MarkerDoc>();
export const pinConverter = makeConverter<PinDoc>();
export const regionConverter = makeConverter<RegionDoc>();
export const configEventConverter = makeConverter<ConfigEventDoc>();
export const messageConverter = makeConverter<MessageDoc>();
export const fragmentConverter = makeConverter<FragmentDoc>();
export const listenConverter = makeConverter<ListenDoc>();

/** Deterministic doc ID for a learner's marker in a region. */
export function markerDocId(userId: string, regionId: string): string {
  return `${userId}_${regionId}`;
}
